import { jsx as _jsx } from "react/jsx-runtime";
export function CloseIcon({ className, size }) {
    return (_jsx("svg", { className: className, xmlns: "http://www.w3.org/2000/svg", height: size + 'px', viewBox: "0 -960 960 960", width: size + 'px', children: _jsx("path", { d: "m289-199-89-90 190-191-190-191 89-91 191 191 191-191 89 91-190 191 190 191-89 90-191-191-191 191Z" }) }));
}
//# sourceMappingURL=CloseIcon.js.map